import { atom } from 'jotai';

export type ReviewActionType = 'copy' | 'export' | 'push';

export type ReviewConfirmationVirtualAnchor = {
  getBoundingClientRect: () => DOMRect;
};

type ReviewConfirmationModalState = {
  isOpen: boolean;
  onConfirm: (() => void) | null;
  actionType: ReviewActionType;
  /** Durable geometry for an initiating control that may unmount while open. */
  dynamicAnchor: ReviewConfirmationVirtualAnchor | null;
};

export const reviewConfirmationModalAtom = atom<ReviewConfirmationModalState>({
  isOpen: false,
  onConfirm: null,
  actionType: 'copy',
  dynamicAnchor: null,
});
